import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SEO from '../components/SEO';

const WhyJoinPage = () => (
  <div className="min-h-screen" style={{ backgroundColor: '#F0EBE2' }}>
    <Navbar />
    <SEO
      title="Why Join the CultureCareers Talent Network"
      path="/talent/why-join"
      description="CultureCareers works with India's leading festivals, galleries, museums and cultural organisations. Be on our network so they can find you for permanent roles, freelance projects and day work."
    />

    {/* Hero */}
    <section className="px-6 md:px-12 lg:px-24 py-20 md:py-28" style={{ backgroundColor: '#0F2942' }}>
      <div className="max-w-3xl">
        <p className="text-xs uppercase tracking-[0.25em] font-medium mb-5" style={{ color: '#D4820A' }}>
          CultureCareers Network
        </p>
        <h1
          className="text-4xl md:text-5xl lg:text-6xl font-light tracking-tight leading-tight mb-6 text-white"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Why <span style={{ color: '#D4820A', fontStyle: 'italic' }}>join</span>?
        </h1>
        <div className="w-20 h-px mb-8" style={{ backgroundColor: 'rgba(212,130,10,0.6)' }} />
        <p className="text-base md:text-lg leading-relaxed font-light max-w-2xl" style={{ color: 'rgba(240, 235, 226, 0.72)' }}>
          CultureCareers works with India&rsquo;s leading festivals, galleries, museums, and cultural organisations. When they need people for a permanent role, a freelance project, or a single day of work, they come to us. Being on our network means they can find you.
        </p>
      </div>
    </section>

    {/* Two-network CTA */}
    <section className="px-6 md:px-12 lg:px-24 py-20 md:py-24">
      <div className="max-w-5xl mx-auto">
        <p className="text-xs uppercase tracking-[0.25em] font-medium mb-5" style={{ color: '#D4820A' }}>
          Two networks. Pick the one that fits.
        </p>
        <h2
          className="text-3xl md:text-4xl font-normal tracking-tight mb-12 max-w-2xl"
          style={{ fontFamily: 'Cormorant Garamond, serif', color: '#0F2942' }}
        >
          Choose how you want to be found.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Link
            to="/talent/professional"
            className="block rounded-xl p-8 md:p-10 transition-all hover:-translate-y-1 hover:shadow-md"
            style={{ backgroundColor: '#FFFFFF', border: '1px solid #F0EBE2' }}
            data-testid="why-join-professional"
          >
            <p className="text-xs uppercase tracking-[0.25em] font-medium mb-3" style={{ color: '#D4820A' }}>
              Professional
            </p>
            <h3
              className="text-2xl md:text-3xl font-normal tracking-tight mb-4"
              style={{ fontFamily: 'Cormorant Garamond, serif', color: '#0F2942' }}
            >
              Professional Talent Network
            </h3>
            <p className="text-base leading-relaxed mb-6" style={{ color: '#0F2942' }}>
              For curators, designers, marketers, producers, educators and creative professionals across India&rsquo;s arts and cultural sector.
            </p>
            <span className="inline-flex items-center text-sm font-medium" style={{ color: '#D4820A' }}>
              Join the network
              <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </span>
          </Link>

          <Link
            to="/talent/crew"
            className="block rounded-xl p-8 md:p-10 transition-all hover:-translate-y-1 hover:shadow-md"
            style={{ backgroundColor: '#FFFFFF', border: '1px solid #F0EBE2' }}
            data-testid="why-join-crew"
          >
            <p className="text-xs uppercase tracking-[0.25em] font-medium mb-3" style={{ color: '#D4820A' }}>
              Crew
            </p>
            <h3
              className="text-2xl md:text-3xl font-normal tracking-tight mb-4"
              style={{ fontFamily: 'Cormorant Garamond, serif', color: '#0F2942' }}
            >
              Event &amp; Festival Crew Network
            </h3>
            <p className="text-base leading-relaxed mb-6" style={{ color: '#0F2942' }}>
              For photographers, sound and AV technicians, stage crew, drivers, hospitality, security and everyone who makes events happen.
            </p>
            <span className="inline-flex items-center text-sm font-medium" style={{ color: '#D4820A' }}>
              Register for gigs
              <svg className="w-4 h-4 ml-2" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </span>
          </Link>
        </div>
      </div>
    </section>

    <Footer />
  </div>
);

export default WhyJoinPage;
